<template>
  <div id="app">
    <router-view></router-view>
    <mainBox v-if="showMainbox && isLogin"></mainBox>
    <div id="appsBox" v-if="isLogin"></div>
  </div>
</template>

<script>
import mainBox from "./views/main.vue";
import actions from "./store/action";
import { getAndTokeUrl } from "@/api/axios"
import { communalPrefix } from "./config";

export default {
  name: "App",
  components: {
    mainBox,
  },
  data() {
    return {
      showMainbox: true,
      notShowRoute: ["/", "/login", "/loginInfo"],
      isLogin: false,
    };
  },
  methods: {
    createUe() {
      window.onload = function () {
        let base = process.env.VUE_APP_BASE_API;
        var oFragmeng = document.createDocumentFragment();
        var date = new Date();
        var time =
          (date.getMonth() + 1).toString() +
          date.getDate() +
          date.getHours() +
          date.getDay();
        var body = document.getElementsByTagName("body")[0];
        var scripts = {
          "ueditorAll/ueditor.config.js": "js",
          "ueditorAll/ueditor.all.js": "js",
          "ueditorAll/lang/zh-cn/zh-cn.js": "js",
        };
        var host = location.origin;
        for (var key in scripts) {
          var url = host + base + "/" + key + "?v=" + time;
          var js = document.createElement("script");
          js.setAttribute("src", url);
          oFragmeng.appendChild(js);
        }
        document.body.appendChild(oFragmeng);
      };
    },
    setIsLogin() {
      this.isLogin = !!localStorage.token;
    },
  },
  created() {
    window.envData = process.env;
    let path = this.$route.path;
    this.showMainbox = this.notShowRoute.indexOf(path) == -1;
    const isRootRoute = window.location.pathname === "/";
    const whiteListTwo = ['/child-contentCenter/valueDelivery/forwardUrl']
    if(whiteListTwo.indexOf(path) !== -1 && this.$route.query.type === '1') {
      let pathV2 = this.$route?.query?.url.split('boss-communal')[1];
      getAndTokeUrl((communalPrefix + pathV2)).then(res => {
        window.open(res.data, '_self')
      })
    } else if (!localStorage.getItem("token") || isRootRoute) {
      history.pushState(null, "/login", "/login");
    }
    this.createUe();
    this.setIsLogin();
  },
  beforeDestroy() {
    // 卸载 store
    actions.offGlobalStateChange();
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1250px;
}

* {
  padding: 0;
  margin: 0;
  outline: none;
}
/* 此处不能给margin  给成padding*/
#appsBox {
  position: relative;
  top: 48px;
}
</style>
